module.exports = __webpack_public_path__ + "static/media/signupicon.86731fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/signupicon.png
// module id = 235
// module chunks = 0